/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconCrush: {
  name: 'crush';
  data: string;
} = {
  name: 'crush',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M306.01 449.437c-39.6 0-71.715 32.1-71.715 71.715 0 39.6 32.1 71.715 71.715 71.715 39.6 0 71.715-32.1 71.715-71.715s-32.115-71.715-71.715-71.715zM557.02 19.117H54.985c-17.94 0-35.865 17.94-35.865 35.865h.045v286.875H90.88l71.715 71.715 71.715-71.715 71.715 71.715 71.715-71.715 71.715 71.715 71.715-71.715h71.715V54.982c0-17.939-17.94-35.865-35.865-35.865z"/></svg>`,
};
